import uuidv4 from '~/utils/uuidv4';
import i18n from '~/localization/i18n';

const defaultActions = () => [
    {
        title: i18n.t('general.ok'),
        action: ({ res }) => res(),
        variant: 'secondary',
    },
    {
        title: i18n.t('general.cancel'),
        action: ({ rej }) => rej(),
        variant: 'text-secondary',
    },
];

const defaultOnClose = ({ res, rej }) => rej();

let index = 0;
let history = [];

export default {
    state: {
        uuid: null,
        open: false,
        resolver: {},
        redirect: null,
        title: '',
        content: '',
        contentHTML: '',
        actions: [],
        center: true, // Allows for toggling the center prop for BaseModal
        onClose: defaultOnClose,
        component: null,
        isError: false,
        windowMode: false, // Allows opening of modal components without any extra functionality other than what comes with base modal, usefull for creating completely custom UX
        payload: null, // Allows for passing data through to a expecting dialog without using any of the fields that affect the dialog view
        props: null, // Allows for passing data through a given component as props,
        listeners: null, // Allows for passing v-on-listeners to a given component,
        order: undefined,
    },
    getters: {
        getState: state => _ => state,
        hasHistory: _ => _ => {
            return index > 1;
        },
    },
    mutations: {
        popState: (state, _) => {
            if (index === 1) {
                state.resolver.res(); // TODO: Perhaps this is not a very good way of closing the dialog
                return;
            }
            index--;
            const newState = history[index - 1];

            Object.entries(newState).forEach(([k, v]) => {
                state[k] = v;
            });
        },
        setTitle: (state, title) => {
            state.title = title;
        },
        openModal: (
            state,
            {
                title,
                content,
                contentHTML,
                isError,
                actions,
                center,
                clickawayOff,
                redirect,
                onClose,
                component,
                then,
                error,
                windowMode,
                payload,
                props,
                listeners,
                order,
            }
        ) =>
            new Promise((res, rej) => {
                if ((!title || (!content && !contentHTML)) && !component)
                    return rej('Missing title and content');
                state.uuid = uuidv4();
                state.open = true;
                state.resolver = { res, rej };
                state.actions = actions ? actions : defaultActions();
                state.center = center ? true : false;
                state.onClose = onClose ? onClose : defaultOnClose;
                state.title = title;
                state.content = content;
                state.contentHTML = contentHTML;
                state.redirect = redirect;
                state.component = component;
                state.isError = isError;
                state.clickawayOff = clickawayOff === true;
                state.windowMode = windowMode;
                state.payload = payload;
                state.props = props;
                state.listeners = listeners;
                state.order = order;
                history[index] = { ...state };
                index++;
            })
                .then(then)
                .catch(error)
                .finally(() => {
                    state.open = false;
                    state.uuid = null;
                    state.resolver = null;
                    state.center = true;
                    state.redirect = null;
                    state.component = null;
                    state.isError = false;
                    state.onClose = defaultOnClose;
                    state.content = '';
                    state.contentHTML = '';
                    state.title = '';
                    state.clickawayOff = false;
                    state.windowMode = false;

                    state.payload = null;
                    state.props = null;
                    state.listeners = null;
                    state.order = undefined;
                    history = [];
                    index = 0;
                }),
    },
};
